/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IDueListPrintRequest } from '../models/due-list-print-request.model';
import { IDueListItem } from '../models/due-list-item.model';

export class LoadDueListItems {
  static readonly type = '[Due List] Load Due List Items via Service';
  constructor() {}
}

export class LoadMyDueListItems {
  static readonly type = '[Due List] Load My Due List Items via Service';
  constructor() {}
}

export class LoadDueListWarnings {
  static readonly type = '[Due List] Load Due List Warnings via Service';
  constructor(
    public filter?: MainTableFilterModel,
    public displayRuntimeChildren?: boolean
  ) {}
}

export class LoadDueListDueCompetences {
  static readonly type = '[Due List] Load Due List Due Competences via Service';
  constructor(
    public filter?: MainTableFilterModel,
    public displayRuntimeChildren?: boolean
  ) {}
}

export class LoadMyDueListWarnings {
  static readonly type = '[Due List] Load My Due List Warnings via Service';
  constructor(
    public filter?: MainTableFilterModel,
    public displayRuntimeChildren?: boolean
  ) {}
}

export class PrintDueListWarnings {
  static readonly type = '[Due List] Print Due List Warnings';
  constructor(public request?: Partial<IDueListPrintRequest>) {}
}

export class LoadDueListCounts {
  static readonly type = '[Due List] Load Due List Counts';
  constructor() {}
}

export class SaveLastDueListItem {
  static readonly type = '[Due List] Save Last Due List Item';
  constructor(public item: IDueListItem) {}
}

export class ClearLastDueListItem {
  static readonly type = '[Due List] Clear Last Due List Item';
  constructor() {}
}

export class LoadLastDueListItem {
  static readonly type = '[Due List] Load Last Due List Item';
  constructor() {}
}
